import { useTheme } from './useTheme';
const borderRadiusMap = {
  sm: '0.125rem',
  default: '3px',
  md: '0.25rem',
  lg: '0.5rem',
  xl: '1rem',
  xxl: '2rem',
  full: '100%'
};
export const useTokens = () => {
  const {
    borderRadius,
    borderWidth,
    boxShadow,
    color,
    space
  } = useTheme();
  const tokens = {
    backgroundColor: {
      default: color['fill-surface-recessed'],
      dark: color['text-core-default'],
      header: color['specialty-table-header-default'],
      light: color['fill-surface-default']
    },
    borderColor: {
      default: color['border-core-subtle'],
      dark: color['border-core-default'],
      light: color['border-core-disabled']
    },
    borderWidth: {
      default: borderWidth[100],
      double: borderWidth[200]
    },
    borderRadius: {
      sm: borderRadiusMap.sm,
      default: borderRadius[100],
      md: borderRadiusMap.md,
      lg: borderRadius[300],
      xl: borderRadius[400],
      xxl: borderRadiusMap.xxl,
      full: borderRadius['full']
    },
    breezeBrand: {
      default: color['breeze-fill-primary-default'],
      // #d20688
      dark: color['breeze-fill-primary-pressed'],
      // #800051
      light: color['breeze-fill-loading-dot-default'],
      // #ff9fcc
      extraLight: color['breeze-fill-secondary-pressed'],
      // #fbdbe9
      extraExtraLight: color['breeze-fill-secondary-hover'],
      // #fcebf2
      secondary: {
        default: color['border-accent-light-orange-default'],
        // #c93700
        light: color['fill-accent-light-orange-default'],
        // #ff4800
        extraLight: color['fill-accent-light-orange-default'],
        // #ffa581
        extraExtraLight: color['fill-accent-orange-subtle-alt'] // #fbddd2
      },
      gradient: {
        dark: color['breeze-fill-special-btn-alt-default'],
        // linear-gradient(114deg, #fc0849, #d20688)
        light: color['breeze-fill-shimmer-default'],
        // linear-gradient(99deg, #fbddd2, #fbdbe9)
        medium: color['breeze-icon-full-page-loader-default'] // linear-gradient(135deg, #fb31a7, #ff4800, #fbddd2)
      }
    },
    dataViz: {
      dataViz1: color['fill-accent-orange-default'],
      // ORANGE
      dataViz2: color['fill-info-default'],
      // AQUA
      dataViz3: color['fill-accent-purple-default'],
      // PURPLE
      dataViz4: color['fill-accent-yellow-default'],
      // YELLOW
      dataViz5: color['fill-accent-red-default'],
      // RED
      dataViz6: color['text-core-disabled'],
      // GREY
      dataViz7: color['fill-accent-green-default'],
      // GREEN
      dataViz8: color['fill-accent-magenta-default'],
      // MAGENTA
      disabled: color['fill-primary-disabled']
    },
    gradient: {
      success: color['fill-positive-default'],
      warning: color['fill-caution-default'],
      danger: color['fill-alert-default'],
      chart: color['fill-accent-magenta-pressed']
    },
    shadow: {
      card: boxShadow[100],
      xs: boxShadow[100],
      sm: boxShadow[200],
      md: boxShadow[300],
      lg: boxShadow[400]
    },
    space: {
      xxxxs: space[25],
      xxxs: space[50],
      xxs: space[100],
      xs: space[200],
      sm: space[300],
      default: space[400],
      md: space[600],
      lg: space[800],
      xl: space[1000],
      xxl: space[1100],
      xxxl: space[1400],
      xxxxl: space[1500]
    },
    textColor: {
      base: color['text-core-default'],
      danger: color['text-alert-default'],
      disabled: color['text-core-disabled'],
      extraLight: color['text-core-subtle'],
      light: color['text-core-subtle'],
      inverse: color['text-core-on-fill-default']
    }
  };
  return {
    tokens
  };
};